<template>
    <div
        id="pro-layout"
        :class="[leftMenuClosed ? 'closed' : 'opened', noMenu ? 'm-0 bg-transparent' : '']"
    >
        <div
            class="sm-top-menu d-block d-sm-none d-flex justify-content-between shadow-sm"
            v-if="showResponsiveBurger"
        >
            <div>
                <v-img
                    src="/images/Logo_Dahub_Official_2019.png"
                    width="130px"
                    height="40px"
                ></v-img>
            </div>
            <div class="mt-auto mb-auto mr-3">
                <v-menu bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                large
                                color="#1398b5"
                            >menu
                            </v-icon
                            >
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            link
                            @click="redirect('/espace-pro/' + token + '/solicitations' + '?no_redirection=true')"
                        >
                            <v-list-item-icon>
                                <v-icon>assignment</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Mes sollicitations</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            link
                            @click="redirect('/espace-pro/' + token + '/review' + '?no_redirection=true')"
                        >
                            <v-list-item-icon>
                                <v-icon>rate_review</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Votre avis</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
        <pro-menu v-if="!noMenu">
        </pro-menu>

        <div
            class="pro-main-container"
            :class="[noMenu ? 'bg-transparent' : '']"
        >
            <pro-dashboard v-if="matchPath('solicitations')"></pro-dashboard>
            <pro-profil v-if="matchPath('profil')"></pro-profil>
            <pro-review v-if="matchPath('review')"></pro-review>
            <cmaj-form v-if="matchPath('formulaire')"></cmaj-form>
            <pro-adhesion v-if="matchPath('adhesion')"></pro-adhesion>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import ProMenu from "./ProMenu"
import ProDashboard from "./ProDashboard"
import ProProfil from "./ProProfil"
import {mapState} from "vuex"
import ProReview from "./ProReview"
import CmajForm from "./CMAJ/CmajForm.vue"
import Confirm from "../tools/Confirm"
import ProAdhesion from "./ProAdhesion"

export default {
    name: "ProLayout",
    components: {ProAdhesion, Confirm, CmajForm, ProReview, ProProfil, ProDashboard, ProMenu},
    data() {
        return {
            token: null,
            noMenu: false,
        }
    },
    methods: {
        matchPath(path) {
            return this.$route.params.pathMatch.includes(path)
        },
        redirect(link) {
            if (this.matchPath("formulaire") && this.isDirty) {
                this.$refs.confirm
                    .open("Attention", "Vous allez quitter la page sans avoir validé ou enregistré votre formulaire.<br>", {
                        color: "red",
                        confirmColor: "red",
                        cancelColor: "#0b697e",
                    })
                    .then((confirm) => {
                        if (confirm) {
                            this.$router.push(link)
                        }
                    })
            } else {
                this.$router.push(link)
            }
        },
    },
    computed: {
        ...mapState("global", ["leftMenuClosed"]),
        ...mapState("web_form", ["isDirty"]),

        showResponsiveBurger() {
            return this.$route.query.origin !== "USKA"
        },
    },

    async created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.noMenu = this.$route.query.hidden && this.$route.query.hidden.includes("APP_MENU")

        this.token = this.$route.params.token
    },
}
</script>
